/**
 * External Dependency Injection Tokens
 * Tokens for injecting external services and configuration into the AB test domain
 */

import { InjectionToken } from '@angular/core';
import {
  ABTestAnalyticsServiceInterface,
  ABTestApiServiceInterface,
  ABTestAuthServiceInterface,
  ABTestCookieConsentServiceInterface,
  ABTestHttpServiceInterface,
  ABTestPermissionServiceInterface,
} from '../interfaces/external';
import { ABTestConfiguration } from '../interfaces/models/ab-test-config.interface';

/**
 * Token for injecting authentication service
 */
export const AB_TEST_AUTH_SERVICE = new InjectionToken<ABTestAuthServiceInterface>('ABTestAuthService', {
  providedIn: 'root',
  factory: () => {
    throw new Error('AB_TEST_AUTH_SERVICE must be provided at the app level');
  },
});

/**
 * Token for injecting API service
 */
export const AB_TEST_API_SERVICE = new InjectionToken<ABTestApiServiceInterface>('ABTestApiService', {
  providedIn: 'root',
  factory: () => {
    throw new Error('AB_TEST_API_SERVICE must be provided at the app level');
  },
});

/**
 * Token for injecting analytics service
 */
export const AB_TEST_ANALYTICS_SERVICE = new InjectionToken<ABTestAnalyticsServiceInterface>('ABTestAnalyticsService', {
  providedIn: 'root',
  factory: () => {
    throw new Error('AB_TEST_ANALYTICS_SERVICE must be provided at the app level');
  },
});

/**
 * Token for injecting AB test configuration
 * Should be provided at the app level with environment-specific settings
 */
export const AB_TEST_CONFIG = new InjectionToken<ABTestConfiguration>('ABTestConfiguration', {
  providedIn: 'root',
  factory: () => {
    throw new Error('AB_TEST_CONFIG must be provided at the app level');
  },
});

/**
 * Token for injecting cookie consent service
 * Used to check if user has opted out of tracking
 */
export const AB_TEST_COOKIE_CONSENT_SERVICE = new InjectionToken<ABTestCookieConsentServiceInterface>(
  'ABTestCookieConsentService',
  {
    providedIn: 'root',
    factory: () => {
      throw new Error('AB_TEST_COOKIE_CONSENT_SERVICE must be provided at the app level');
    },
  }
);

/**
 * Token for injecting permission service
 * Used to check user permissions for AB test targeting
 */
export const AB_TEST_PERMISSION_SERVICE = new InjectionToken<ABTestPermissionServiceInterface>(
  'ABTestPermissionService',
  {
    providedIn: 'root',
    factory: () => {
      throw new Error('AB_TEST_PERMISSION_SERVICE must be provided at the app level');
    },
  }
);

/**
 * Token for injecting HTTP service
 * Used for making authenticated HTTP requests
 */
export const AB_TEST_HTTP_SERVICE = new InjectionToken<ABTestHttpServiceInterface>('ABTestHttpService', {
  providedIn: 'root',
  factory: () => {
    throw new Error('AB_TEST_HTTP_SERVICE must be provided at the app level');
  },
});

/**
 * Token for injecting API base URL
 * Used to construct full API endpoint URLs
 */
export const AB_TEST_BASE_URL = new InjectionToken<string>('ABTestBaseUrl', {
  providedIn: 'root',
  factory: () => {
    throw new Error('AB_TEST_BASE_URL must be provided at the app level');
  },
});
